import { Typography, useTheme } from '@mui/material';
import { Box, useMediaQuery } from '@mui/system';
import React, { FC } from 'react';

import { StyledCTAButton } from 'infrastructure/components/HorizontalCard/style';
import {
  formatToCurrency,
  isAustralia,
  isUS,
} from 'infrastructure/targets/web/modules/common/helpers';
import { getFirstTimeLessonImage } from 'infrastructure/targets/web/modules/common/imageUrlHelpers';

import {
  BackgroundImageFrame,
  StyledFirstTimeLessonCardContainer,
  StyledFirstTimeLessonImage,
  StyledPricingContainer,
  StyledPricingText,
  StyledRightSideContentContainer,
} from './style';

interface IFirstTimeLessonCard {
  onCardClick: () => void;
  content: string;
  instructorsLoading: boolean;
}

const FirstTimeLessonCard: FC<IFirstTimeLessonCard> = ({
  onCardClick,
  content,
  instructorsLoading,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const imageSizeMobile = { width: '40px', height: '28px' };
  const imageSizeVariant = { width: '400px', height: '282px' };
  const imageSize = isMobile ? imageSizeMobile : imageSizeVariant;
  return (
    <StyledFirstTimeLessonCardContainer>
      <BackgroundImageFrame>
        <StyledFirstTimeLessonImage
          component={'img'}
          src={getFirstTimeLessonImage()}
          sx={{
            ...imageSize,
          }}
        />
      </BackgroundImageFrame>
      <StyledRightSideContentContainer>
        <Box>
          <Typography variant="h2"> First Time Lesson?</Typography>
        </Box>
        <Box>
          <Typography variant="h6">Get Paired Up With a Five Iron Coach</Typography>
        </Box>
        <Box>
          <Typography variant="body1" sx={{ color: 'var(--text-secondary, #555)' }}>
            {content}
          </Typography>
        </Box>
        <StyledPricingContainer>
          <StyledPricingText variant="h3">
            {isUS
              ? formatToCurrency(99)
              : isAustralia()
              ? formatToCurrency(199)
              : formatToCurrency(500)}
          </StyledPricingText>
          <Typography variant="body1">/1 Hour</Typography>
        </StyledPricingContainer>
        <Box>
          <StyledCTAButton
            variant="contained"
            color="primary"
            size="large"
            disabled={instructorsLoading}
            onClick={() => onCardClick()}>
            Reserve Now
          </StyledCTAButton>
        </Box>
      </StyledRightSideContentContainer>
    </StyledFirstTimeLessonCardContainer>
  );
};

export default FirstTimeLessonCard;
